import { render, staticRenderFns } from "./TaxLookup.vue?vue&type=template&id=2df1908e&scoped=true&lang=pug"
import script from "./TaxLookup.vue?vue&type=script&lang=ts"
export * from "./TaxLookup.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./TaxLookup.vue?vue&type=style&index=0&id=2df1908e&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2df1908e",
  null
  ,true
)

export default component.exports